import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function IndianaAchievementWalletIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 159.3 159.3"
  }, props, {
    contextType: contextType,
    className: `pi pi-indiana-achievement-wallet-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "79.6",
    cy: "79.6",
    r: "79.6",
    fill: "#4d4285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 119.3c-1.9-.1-3.5-.8-5-1.9-1.2-.9-2.1-2.2-2.7-3.6-.5-1.2-.6-2.5-.5-3.9 0-.2 0-.3.1-.5.7-2.2 1.4-4.4 2.2-6.6 1.1-3.2 2.2-6.3 3.3-9.5.7-1.9 1.4-3.8 2-5.7l3.3-9.6c.7-2.1 1.4-4.2 2.2-6.3 1.1-3.3 2.3-6.6 3.4-9.9 1.9-5.4 3.7-10.8 5.6-16.1.5-1.3.9-2.6 1.4-3.9.6-1.4 1.6-2 3.2-1.6.6.2.9.5 1.1 1.1 1 2.9 2 5.9 3 8.8 1.4 4.1 2.9 8.3 4.4 12.4 1.5 4.2 2.9 8.5 4.4 12.7 1.9 5.4 3.7 10.8 5.6 16.2 1.6 4.7 3.3 9.4 4.9 14.1 1.5 4.3 3.1 8.6 4.6 12.9 0 .1.1.2.1.4 0 .3-.2.4-.5.4h-2c-14.3 0-28.6.2-42.9.2-.4-.1-.8-.1-1.2-.1zM134.1 40c-.9 2.6-1.8 5.2-2.7 7.7L126 63.3l-3 8.7-1.5 4.2-3.3 9.3c-1.7 4.9-3.3 9.8-5 14.7-1.3 3.7-2.6 7.3-3.8 10.9-.7 1.9-1.3 3.8-2 5.6 0 .1-.2.5-.3.7-.3.6-.6 1.2-1.4 1.5-.5.1-1.1.1-1.5 0-.9-.2-1.2-1-1.5-1.8-.8-2.3-1.6-4.6-2.4-6.8-.9-2.7-1.9-5.4-2.9-8.1-.6-1.8-1.2-3.6-1.8-5.3-.2-.5-.1-.9 0-1.4 1.4-4 2.8-8 4.2-11.9.7-2 1.4-4 2.1-5.9 1.1-3.3 2.2-6.5 3.4-9.8l5.4-15.6c1.3-3.7 2.6-7.3 3.9-11 .2-.5.4-.9.6-1.4 6.2.2 12.6.1 18.9.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9 40.1c-1.7 1.5-2.8 3.5-3.3 5.6-.6 2.5-.2 5 .7 7.4 1.4 3.9 2.8 7.7 4.1 11.6 1.1 3.2 2.2 6.5 3.3 9.7 1.4 4 2.7 7.9 4.1 11.9 1.4 4.1 2.8 8.1 4.3 12.2.2.5.2.8 0 1.3-1.4 4-2.8 8.1-4.2 12.1-.6 1.8-1.2 3.7-1.8 5.5-.4 1.3-2.1 2.2-3.3 1.7-.6-.3-1-.8-1.2-1.5-.5-1.3-.9-2.7-1.4-4l-2.1-6c-.9-2.6-1.8-5.3-2.7-7.9-1.6-4.6-3.1-9.1-4.7-13.7-1.1-3.2-2.3-6.4-3.4-9.6-2.1-6-4.2-12.1-6.2-18.1-.8-2.4-1.7-4.9-2.6-7.3-.6-1.6-.6-3.2-.2-4.8.8-2.8 2.5-4.7 5.3-5.7.5-.2 1.1-.2 1.7-.4h12.4c.4-.1.9-.1 1.2 0z",
    fill: "#fffeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 47.1c.5-2.8 2-4.8 4.4-6.2.9-.6 1.8-.8 3-.8H114c-1 2.8-2 5.7-3 8.5-1.3 3.8-2.7 7.7-4 11.5-1.3 3.7-2.5 7.4-3.8 11.1l-3.3 9.3c-1.6 4.5-3.1 9-4.6 13.5-.1.2-.2.5-.3.9-.3-.8-.6-1.6-.8-2.3-1.5-4.3-2.9-8.5-4.4-12.8l-4.5-12.9c-.9-2.5-1.8-5-2.6-7.5-1-2.8-1.9-5.7-2.9-8.5-.4-1.1-.5-2.2-.4-3.3-.2-.2-.2-.3-.2-.5z",
    fill: "#fff"
  })));
}